import React from 'react';
import PropTypes from 'prop-types';

import Deals from './deals';
import Headers from './headers';
import Totals from './totals';

import './styles.scss';

export default function DealsTable({ deals, hideTotals, orderedColumns, sortable }) {

  return (
    <div className="table-container">
      <table className="table deals-table">
        <thead>
          <Headers orderedColumns={orderedColumns} sortable={sortable} />
        </thead>
        <tbody>
          {!hideTotals && <Totals deals={deals} orderedColumns={orderedColumns} />}
          <Deals deals={deals} orderedColumns={orderedColumns} />
        </tbody>
      </table>
    </div>
  );
}

DealsTable.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object).isRequired,
  hideTotals: PropTypes.bool,
  orderedColumns: PropTypes.array.isRequired,
  sortable: PropTypes.bool,
};
